import { render, staticRenderFns } from "./mo_confirm.vue?vue&type=template&id=5c00f714&"
import script from "./mo_confirm.vue?vue&type=script&lang=js&"
export * from "./mo_confirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports